export default "__VITE_ASSET__4a8a2c98__"